import { render, staticRenderFns } from "./PtStopDetails.vue?vue&type=template&id=a0a62ac6&"
import script from "./PtStopDetails.vue?vue&type=script&lang=js&"
export * from "./PtStopDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports